var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"to-top",style:({
		transform: _vm.transform,
		bottom: _vm.bottom,
	}),on:{"click":_vm.toTop}})
}
var staticRenderFns = []

export { render, staticRenderFns }